import * as trace from 'owa-trace';
import { getAccessTokenforResource } from 'owa-tokenprovider';
import { isNullOrUndefined } from 'mini-common-utils/lib/utils/isNullOrUndefined';
import { ErrorCodes } from '../utils/errorCodes';

/**
 * This method is responsible for adding the required headers and the correct token to make the SDS network call.
 */

export async function makeSDSNetworkCall(url: string, method?: string, body?: any) {
    let response = null;
    const isBodyPresent: boolean = !isNullOrUndefined(body);
    try {
        const substrateToken = await getAccessTokenforResource(window.location.origin);
        const substrateHeaders = new Headers();
        substrateHeaders.append('Accept', 'application/json');
        substrateHeaders.append('Authorization', 'Bearer ' + substrateToken);
        substrateHeaders.append('Prefer', 'exchange.behavior="applicationdata"');
        substrateHeaders.append('Content-type', 'application/json');
        const serviceData = await fetch(url, {
            headers: substrateHeaders,
            method: method ? method : 'GET',
            body: JSON.stringify(body),
        });
        response = await serviceData.json();
        const shouldSuppressErrorLogs: boolean =
            response?.error?.code === ErrorCodes.CollectionIdNotFound && method === 'GET';
        if (response?.error && !shouldSuppressErrorLogs) {
            const { code = '', message = '' } = response.error;
            trace.errorThatWillCauseAlert(
                'SDS api error, Method - ' +
                    method +
                    ', code - ' +
                    code +
                    ', message - ' +
                    message +
                    ', body present - ' +
                    isBodyPresent
            );
        }
    } catch (e) {
        response = null;
        trace.errorThatWillCauseAlert(
            'SDS api failure, Method - ' + method + ', body present - ' + isBodyPresent
        );
    }
    return response;
}
